import { useState } from "react";
import "./styles.css";
import { FaceScan } from "./FaceScan";
import { TopHeadValidate } from "./TopHeadValidate";
import { HeadInitialize } from "./HeadInitialize";
import { HeadScan } from "./HeadScan";
import { useConfig } from "../../context/ConfigContext";
import { useScanImage } from "../../context/ImageContext";

export const ScanModule = ({
  faceModel,
  runNextModule = () => {},
  onError = () => {},
  onExitClick = () => {},
}) => {
  const { addFrontImage, addSideImage, validateTopHeadImage } = useScanImage();
  const { configData } = useConfig();

  const [currentStep, updateCurrentStep] = useState(0);
  const [showHeadTutorial, setShowHeadTutorial] = useState(true);

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <HeadInitialize
            onSkipClick={runNextModule}
            onContinueClick={() => updateCurrentStep(2)}
          />
        );
      case 2:
        return (
          <HeadScan
            onBack={showHeadTutorial ? () => updateCurrentStep(1) : undefined}
            onFinish={runNextModule}
            addImage={addSideImage}
          />
        );
      case 3:
        return (
          <TopHeadValidate
            onBack={() => {
              setShowHeadTutorial(false);
              updateCurrentStep(2);
            }}
            onContinue={runNextModule}
            onError={onError}
            validateTopHeadImage={validateTopHeadImage}
          />
        );
      default:
        return (
          <FaceScan
            sideFaceEnabled={configData.FaceModuleFlags.sideScanEnabled}
            addFrontImage={addFrontImage}
            addSideImage={addSideImage}
            runFaceModel={faceModel}
            onExitClick={onExitClick}
            onComplete={() => {
              !configData.HeadModuleFlags.isEnabled
                ? runNextModule()
                : updateCurrentStep(1);
            }}
            onError={onError}
          />
        );
    }
  };

  return <div className="scan-module">{renderCurrentStep()}</div>;
};
